// `video.overlay`: a cut-out over a base video at one of 9 places, live's `VIDEO_OVERLAY` (spec
// G14-templates, "The steps"), the worker's own ffmpeg. Live lists no such job; a template's run
// starts it.
import { VideoOverlayQuote, VideoOverlayRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.overlay"> = {
  type: "video.overlay",
  label: "Overlay",
  source: "form",
  pair: "video.overlay",
  fields: () => ({}),
  request: VideoOverlayRequest,
  quote: VideoOverlayQuote,
};
